import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import CustomRadio from "../../../../components/common/CustomRadio/CustomRadio";
import CustomMonthYear from "../../../../components/common/CustomMonthYear/CustomMonthYear";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import { Form, FormikProvider, useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
   MAX_FILE_SIZE,
   MAX_FILE_SIZE_MESSAGE,
   isValidFileType,
} from "../../../../helpers/fileValidationRules";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import RouteNames from "../../../../AppRoutes/RouteName";
import {
   addVehicleAndEmiDetailsAsync,
   downloadVehiclePDF,
   updateFleetAsync,
} from "../../../../redux/features/fleetMaster";
import { useNavigate, useParams } from "react-router-dom";
import { MAX_DATE } from "../../../../Hooks/dateValidationRules";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import { useBoolean } from "../../../../Hooks/useBoolean";
import { fleetVendorEMIReportAsync } from "../../../../redux/features/reportSlice";
import * as XLSX from "xlsx";
import { BASE_URL_IMAGE } from "../../../../Api/client";

const validationSchema = Yup.object().shape({
   vehicleNo: Yup.string().required("Vehicle No is required"),
   chasisNo: Yup.string().required("Chassis No is required"),
   engineNo: Yup.string().required("Engine No is required"),
   vehicleOwnerName: Yup.string().required("Vehicle Owner Name is required"),
   fastagBankName: Yup.string().required("Fastag Bank Name is required"),
   vehicleCategory: Yup.string().required("Vehicle Category is required"),
   location: Yup.string().required("Location is required"),
   // kiloleter: Yup.string().required("Kiloleter is required"),
   company: Yup.string().required("Company is required"),
   tonnage: Yup.string().required("Tonnage is required"),
   fuelType: Yup.string().required("Fuel Type is required"),
   make: Yup.string().required("Make Name is required"),
   model: Yup.date()
      .required("Model Month Year is required")
      .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
   registrationCertificate: Yup.mixed()
      .required("Registration Certificate is required")
      .test("is-valid-type", "Not a valid document type", (value) => {
         if (typeof value !== "object") return true;
         return isValidFileType(value && value.name.toLowerCase(), "all");
      })
      .test("is-valid-size", MAX_FILE_SIZE_MESSAGE, (value) => {
         if (typeof value !== "object") return true;
         return value && value.size <= MAX_FILE_SIZE;
      }),
   insuranceExpiryDate: Yup.date()
      .required("Insurance Expiry Date is required")
      .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
   // insuranceAmount: Yup.number()
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .required("Insurance Amount is required")
   //    .min(0, "Must be a positive value"),
   insuranceCertificate: Yup.mixed()
      .required("Insurance Certificate is required")
      .test("is-valid-type", "Not a valid document type", (value) => {
         if (typeof value !== "object") return true;
         return isValidFileType(value && value.name.toLowerCase(), "all");
      })
      .test("is-valid-size", MAX_FILE_SIZE_MESSAGE, (value) => {
         if (typeof value !== "object") return true;
         return value && value.size <= MAX_FILE_SIZE;
      }),
   fitnessExpiryDate: Yup.date()
      .required("Fitness Expiry Date is required")
      .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
   // fitnessAmount: Yup.number()
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .required("Fitness Amount is required")
   //    .min(0, "Must be a positive value"),
   fitnessCertificate: Yup.mixed()
      .required("Fitness Certificate is required")
      .test("is-valid-type", "Not a valid document type", (value) => {
         if (typeof value !== "object") return true;
         return isValidFileType(value && value.name.toLowerCase(), "all");
      })
      .test("is-valid-size", MAX_FILE_SIZE_MESSAGE, (value) => {
         if (typeof value !== "object") return true;
         return value && value.size <= MAX_FILE_SIZE;
      }),
   // localPermitExpiryDate: Yup.date()
   //    // .required("Local Permit Expiry Date is required")
   //    .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
   // localPermitAmount: Yup.number()
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .required("Local Permit Amount is required")
   //    .min(0, "Must be a positive value"),
   // localPermitDocument: Yup.mixed()
   //    .required("Local Permit Document is required")
   //    .test("is-valid-type", "Not a valid document type", (value) => {
   //       if (typeof value !== "object") return true;
   //       return isValidFileType(value && value.name.toLowerCase(), "all");
   //    })
   //    .test("is-valid-size", MAX_FILE_SIZE_MESSAGE, (value) => {
   //       if (typeof value !== "object") return true;
   //       return value && value.size <= MAX_FILE_SIZE;
   //    }),

   nationalPermitExpiryDate: Yup.date()
      .required("National Permit Expiry Date is required")
      .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
   nationalPermitAmount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      // .required("National Permit Amount is required and must be a number")
      .min(0, "Must be a positive value"),

   nationalPermitDocument: Yup.mixed()
      .required("Local Permit Document is required")
      .test("is-valid-type", "Not a valid document type", (value) => {
         if (typeof value !== "object") return true;
         return isValidFileType(value && value.name.toLowerCase(), "all");
      })
      .test("is-valid-size", MAX_FILE_SIZE_MESSAGE, (value) => {
         if (typeof value !== "object") return true;
         return value && value.size <= MAX_FILE_SIZE;
      }),

   pucExpiryDate: Yup.date()
      .nullable()
      .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
   // pucAmount: Yup.number()
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .required("PUC Amount is required")
   //    .min(0, "Must be a positive value"),

   pucDocument: Yup.mixed().nullable(),

   pesoExpiryDate: Yup.date()
      .required("PESO Expiry Date is required")
      .max(MAX_DATE, "The date cannot be later than December 31, 2999"),

   // pesoAmount: Yup.number()
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .required("PESO Amount is required and must be a number")
   //    .min(0, "Must be a positive value"),

   // pesoDocument: Yup.mixed()
   // .required("File is required")
   // .test("is-valid-type", "Not a valid document type", (value) => {
   //    if (typeof value !== "object") return true;
   //    return isValidFileType(value && value.name.toLowerCase(), "all");
   // })
   // .test("is-valid-size", MAX_FILE_SIZE_MESSAGE, (value) => {
   //    if (typeof value !== "object") return true;
   //    return value && value.size <= MAX_FILE_SIZE;
   // }),

   mvTax: Yup.mixed()
      .required("MV Tax is required")
      .test("is-valid-type", "Not a valid document type", (value) => {
         if (typeof value !== "object") return true;
         return isValidFileType(value && value.name.toLowerCase(), "all");
      })
      .test("is-valid-size", MAX_FILE_SIZE_MESSAGE, (value) => {
         if (typeof value !== "object") return true;
         return value && value.size <= MAX_FILE_SIZE;
      }),
   mvTaxExpiryDate: Yup.date()
      .required("MV Tax Expiry Date is required")
      .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
   // mvTaxAmount: Yup.number()
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .required("MV Tax Amount is required")
   //    .min(0, "Must be a positive value"),
   gpsProviderName: Yup.string().nullable(),
   // gpsAmount: Yup.number()
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .transform((value) => (isNaN(value) ? undefined : value))
   //    .min(0, "Must be a positive value")
   //    .nullable(),
   fabricatorName: Yup.string().nullable(),
   fabricatorLocation: Yup.string().nullable(),
   consultantPerson: Yup.string().nullable(),
   consultantPhone: Yup.string().nullable(),

   // ----------------------- EMI -----------------------
   isEmi: Yup.boolean(),
   emiStartDate: Yup.date().when("isEmi", {
      is: true,
      then: (schema) =>
         schema
            .required("EMI Start Date is required")
            .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
      otherwise: (schema) => schema.nullable(),
   }),

   emiEndDate: Yup.date().when("isEmi", {
      is: true,
      then: (schema) =>
         schema
            .required("EMI End Date is required")
            .max(MAX_DATE, "The date cannot be later than December 31, 2999"),
      otherwise: (schema) => schema.nullable(),
   }),

   monthlyEmiObligationDate: Yup.number().when("isEmi", {
      is: true,
      then: (schema) =>
         schema
            .required("EMI Obligation Date is required")
            .max(31, "The date cannot be later than 31")
            .min(1, "The date cannot be less than 1"),
      otherwise: (schema) => schema.nullable(),
   }),

   emiAmount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .when("isEmi", {
         is: true,
         then: (schema) =>
            schema
               .required("EMI Amount is required and must be a number")
               .min(0, "Must be a positive value"),
         otherwise: (schema) => schema.nullable(),
      }),

   noEMIAmount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .when("isEmi", {
         is: true,
         then: (schema) =>
            schema
               .required("Number of EMI is required and must be a number")
               .min(0, "Must be a positive value"),
         otherwise: (schema) => schema.nullable(),
      }),

   totalLoanAmount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .when("isEmi", {
         is: true,
         then: (schema) =>
            schema
               .required("Total EMI Amount is required and must be a number")
               .min(0, "Must be a positive value"),
         otherwise: (schema) => schema.nullable(),
      }),

   financedBy: Yup.string().when("isEmi", {
      is: true,
      then: (schema) => schema.required("Financed By Name is required"),
      otherwise: (schema) => schema.nullable(),
   }),
});

const initialValues = {
   isEmi: false,
   vehicleNo: "",
   chasisNo: "",
   engineNo: "",
   vehicleOwnerName: "",
   dimension: "",
   fastagBankName: "",
   vehicleCategory: "",
   location: "",
   company: "",
   // kiloleter: "",
   tonnage: "",
   fuelType: "Diesel",
   make: "",
   model: "",
   registrationCertificate: null,
   insuranceExpiryDate: "",
   insuranceAmount: 0,
   insuranceCertificate: null,
   fitnessExpiryDate: "",
   fitnessAmount: 0,
   fitnessCertificate: null,
   localPermitExpiryDate: "",
   localPermitAmount: 0,
   localPermitDocument: null,
   nationalPermitExpiryDate: "",
   nationalPermitAmount: 0,
   nationalPermitDocument: null,
   pucExpiryDate: "",
   pucAmount: 0,
   pucDocument: null,
   mvTax: null,
   mvTaxExpiryDate: "",
   mvTaxAmount: 0,
   gpsProviderName: "",
   gpsAmount: 0,
   fabricatorName: "",
   fabricatorLocation: "",
   consultantPerson: "",
   consultantPhone: "",

   pesoExpiryDate: "",
   pesoAmount: 0,
   pesoDocument: null,

   // ------------------------- EMI -----------------------------
   emiStartDate: "",
   emiEndDate: "",
   emiAmount: "",
   monthlyEmiObligationDate: "",
   // emiCertificate: null,
   financedBy: "",
   noEMIAmount: "",
   totalLoanAmount: "",
};

const VehicleDetails = ({ singleFleetMaster }) => {
   const params = useParams();
   const dispatch = useDispatch();
   const navigate = useNavigate();

   const fleetMaster = useSelector((state) => state.fleetMaster);

   const reportPopup = useBoolean();
   const expirationReportPopup = useBoolean();

   const tonnageData = Object.values(fleetMaster?.tonnage)?.map((item) => ({
      label: item?.tonnage,
      value: item?.id,
   }));

   const makeData = fleetMaster?.make?.map?.((item) => ({
      label: item?.make,
      value: item?.id,
   }));
   const dimensionData = fleetMaster?.dimension?.map?.((item) => ({
      label: item?.dimension,
      value: item?.id,
   }));
   const vehicleCategoryData = fleetMaster?.vehicleCategory?.map?.((item) => ({
      label: item?.category_name,
      value: item?.id,
   }));

   const locationData = fleetMaster?.location?.map?.((item) => ({
      label: item?.name,
      value: item?.id,
   }));

   const kiloleterData = fleetMaster?.kiloleters?.map?.((item) => ({
      label: item?.kiloleter_value,
      value: item?.id,
   }));

   const companyData = fleetMaster?.companies?.map?.((item) => ({
      label: item?.company_name,
      value: item?.id,
   }));

   const updateFleetMaster = (formData) => {
      const cleanValue = (val) =>
         val === "" ||
         val === "null" ||
         val === null ||
         val === undefined
            ? ""
            : val;

      const data = {
         id: params?.id,
         _method: "POST",
         vehicle_no: formData.vehicleNo,
         chasis_no: formData.chasisNo,
         engine_no: formData.engineNo,
         vehicle_owner_name: formData.vehicleOwnerName,
         //dimension_id: formData.dimension,
         fastag_bank_name: formData.fastagBankName,
         vehicle_category_id: formData.vehicleCategory,
         tonnage_id: formData.tonnage,
         fuel_type: formData.fuelType,
         make_id: formData.make,
         model: formData.model,
         insurance_expiry_date: formData.insuranceExpiryDate,
         insurance_amount: formData.insuranceAmount,
         fitness_expiry_date: formData.fitnessExpiryDate,
         fitness_amount: formData.fitnessAmount,
         local_permit_expiry_date: cleanValue(formData.localPermitExpiryDate),
         local_permit_amount: formData.localPermitAmount,
         national_permit_expiry_date: formData.nationalPermitExpiryDate,
         national_permit_amount: formData.nationalPermitAmount,
         puc_expiry_date: formData.pucExpiryDate ? formData.pucExpiryDate : "",
         puc_amount: formData.pucAmount,
         mv_tax_expiry_date: formData.mvTaxExpiryDate,
         mv_tax_amount: formData.mvTaxAmount,
         gps_provider_name: cleanValue(formData.gpsProviderName),
         gps_amount: formData.gpsAmount ? formData.gpsAmount : 0,
         fabricator_name: cleanValue(formData.fabricatorName),
         fabricator_location: cleanValue(formData.fabricatorLocation),
         consultant_person: cleanValue(formData.consultantPerson),
         consultant_phone: cleanValue(formData.consultantPhone),
         emi_start_date: formData.emiStartDate,
         emi_end_date: formData.emiEndDate,
         emi_amount: formData.emiAmount ? formData.emiAmount : 0,
         financed_by: formData.financedBy,
         model_id: 3,
         action_id: 2,

         registration_certificate: formData?.registrationCertificate,
         insurance_certificate: formData.insuranceCertificate,
         local_permit_document: formData.localPermitDocument,
         national_permit_document: formData.nationalPermitDocument,
         puc_document: formData.pucDocument,
         mv_tax_document: formData.mvTax,
         emi_certificate: formData.insuranceCertificate,
         fitness_certificate: formData.fitnessCertificate,

         location_id: formData.location,
         // kiloleter_id: formData.kiloleter,
         company_id: formData.company,
         peso_expiry_date: formData.pesoExpiryDate,
         peso_amount: formData.pesoAmount,
         peso_document: formData.pesoDocument,

         purchase_date: formData.purchaseDate,
         purchase_amount: formData.purchaseAmount,
         purchase_document: formData.purchaseDocument,

         emi_monthly_obligation_date: formData?.monthlyEmiObligationDate,
         emi_number: formData?.noEMIAmount,
         total_emi_amount: formData?.totalLoanAmount,

         isEmi: formData?.isEmi ? 1 : 0,
      };
      if (formData?.dimension) {
         data.dimension_id = formData?.dimension;
      }

      typeof data.registration_certificate !== "object" &&
         delete data.registration_certificate;
      typeof data.insurance_certificate !== "object" && delete data.insurance_certificate;
      typeof data.local_permit_document !== "object" && delete data.local_permit_document;
      typeof data.national_permit_document !== "object" &&
         delete data.national_permit_document;
      typeof data.puc_document !== "object" && delete data.puc_document;
      typeof data.mv_tax_document !== "object" && delete data.mv_tax_document;
      typeof data.emi_certificate !== "object" && delete data.emi_certificate;
      typeof data.fitness_certificate !== "object" && delete data.fitness_certificate;
      if (!data.puc_amount || data.puc_amount == 0) {
         delete data.puc_amount;
      }

      // console.log(typeof data.fitness_certificate, data.fitness_certificate);
      // return;

      const newData = new FormData();

      Object.keys(data).forEach((key) => {
         newData.append(key, data[key]);
      });

      dispatch(backdropLoadingAction(true));

      dispatch(
         updateFleetAsync({
            data: newData,
            err: () => {
               dispatch(backdropLoadingAction(false));
               //toast.error("Something went wrong !");
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Record updated successfully !");
               navigate(RouteNames.fleetMasterList);
            },
         }),
      );
   };

   const handleDownloadVehiclePDF = (fleetMasterId) => {
      const newData = new FormData();
      newData.append("fleet_master_id", fleetMasterId);

      dispatch(
         downloadVehiclePDF({
            data: newData,
            err: () => {
               dispatch(backdropLoadingAction(false));
               //toast.error("Something went wrong!");
            },
            done: (res) => {
               dispatch(backdropLoadingAction(false));

               if (!res || !res.url) {
                  //toast.error("Invalid PDF response!");
                  return;
               }

               // Safely construct the full file URL
               const fileUrl = `${BASE_URL_IMAGE.replace(/\/+$/, "")}/${res.url.replace(/^\/+/, "")}`;

               // Create a hidden link to trigger the download
               const link = document.createElement("a");
               link.href = fileUrl;
               link.target = "_blank";
               link.setAttribute("download", "vehicle_details.pdf");
               link.style.display = "none";

               document.body.appendChild(link);
               link.click();
               document.body.removeChild(link);

               toast.success("PDF downloaded successfully!");
            },
         }),
      );
   };

   const formik = useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      enableReinitialize: true,
      onSubmit: updateFleetMaster,
   });

   const {
      errors,
      values,
      touched,
      getFieldProps,
      handleSubmit,
      setFieldValue,
      setValues,
   } = formik;

   useEffect(() => {
      const normalizeText = (val) =>
         val === null || val === undefined || val === "null" ? "" : val;

      setValues({
         isEmi: singleFleetMaster?.is_emi,
         vehicleNo: singleFleetMaster?.vehicle_no,
         chasisNo: singleFleetMaster?.chasis_no,
         engineNo: singleFleetMaster?.engine_no,
         vehicleOwnerName: singleFleetMaster?.vehicle_owner_name,
         dimension: singleFleetMaster?.dimension_id,
         fastagBankName: singleFleetMaster?.fastag_bank_name,
         vehicleCategory: singleFleetMaster?.vehicle_category?.id,
         tonnage: singleFleetMaster?.tonnage?.id,
         fuelType: singleFleetMaster?.fuel_type,
         make: singleFleetMaster?.make?.id,
         model: singleFleetMaster?.model,
         registrationCertificate: singleFleetMaster?.registration_certificate,
         insuranceExpiryDate: singleFleetMaster?.insurance_expiry_date,
         insuranceAmount: singleFleetMaster?.insurance_amount,
         insuranceCertificate: singleFleetMaster?.insurance_certificate,
         fitnessExpiryDate: singleFleetMaster?.fitness_expiry_date,
         fitnessAmount: singleFleetMaster?.fitness_amount,
         fitnessCertificate: singleFleetMaster?.fitness_certificate,
         localPermitExpiryDate: singleFleetMaster?.local_permit_expiry_date,
         localPermitAmount: singleFleetMaster?.local_permit_amount,
         localPermitDocument: singleFleetMaster?.local_permit_document,
         nationalPermitExpiryDate: singleFleetMaster?.national_permit_expiry_date,
         nationalPermitAmount: singleFleetMaster?.national_permit_amount,
         nationalPermitDocument: singleFleetMaster?.national_permit_document,
         pucExpiryDate: singleFleetMaster?.puc_expiry_date,
         pucAmount: singleFleetMaster?.puc_amount,
         pucDocument: singleFleetMaster?.puc_document,
         mvTax: singleFleetMaster?.mv_tax_document,
         mvTaxExpiryDate: singleFleetMaster?.mv_tax_expiry_date,
         mvTaxAmount: singleFleetMaster?.mv_tax_amount,
         gpsProviderName: normalizeText(singleFleetMaster?.gps_provider_name),
         gpsAmount: singleFleetMaster?.gps_amount,
         fabricatorName: normalizeText(singleFleetMaster?.fabricator_name),
         fabricatorLocation: normalizeText(singleFleetMaster?.fabricator_location),
         consultantPerson: normalizeText(singleFleetMaster?.consultant_person),
         consultantPhone: normalizeText(singleFleetMaster?.consultant_phone),

         // EMI
         emiStartDate: singleFleetMaster?.emi_start_date,
         emiEndDate: singleFleetMaster?.emi_end_date,
         emiAmount: singleFleetMaster?.emi_amount,
         // emiCertificate: singleFleetMaster?.emi_certificate,
         financedBy: singleFleetMaster?.financed_by,

         // kiloleter: singleFleetMaster?.kiloleter_id,
         location: singleFleetMaster?.location_id,
         company: singleFleetMaster?.company_id,
         pesoExpiryDate: singleFleetMaster?.peso_expiry_date,
         pesoAmount: singleFleetMaster?.peso_amount,
         pesoDocument: singleFleetMaster?.peso_document,

         purchaseDate: singleFleetMaster?.purchase_date,
         purchaseAmount: singleFleetMaster?.purchase_amount,
         purchaseDocument: singleFleetMaster?.purchase_document,

         monthlyEmiObligationDate: singleFleetMaster?.emi_monthly_obligation_date,
         noEMIAmount: singleFleetMaster?.emi_number,
         totalLoanAmount: singleFleetMaster?.total_emi_amount,
      });
   }, [singleFleetMaster]);

   //   console.log({ values });

   return (
      <FormikProvider value={formik}>
         <div className="mb-3 d-flex justify-content-end">
            <button
               type="button"
               className="btn btn-info"
               onClick={() => handleDownloadVehiclePDF(params?.id)}
            >
               Download Vehicle PDF
            </button>
         </div>

         <Form noValidate>
            <div
               className="tab-pane fade show active"
               id="0"
               role="tabpanel"
               aria-labelledby="0"
            >
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Vehicle Details</h3>
                  </div>

                  <div className="row card-body">
                     {/* Vehicle No Sec */}
                     <div className="col-lg-4">
                        <CustomInput
                           require
                           label="Vehicle No"
                           id="vehicleNo"
                           placeholder="Enter Vehicle No"
                           {...getFieldProps("vehicleNo")}
                           errors={
                              Boolean(errors.vehicleNo) && Boolean(touched.vehicleNo)
                           }
                           message={errors.vehicleNo}
                        />
                     </div>
                     <div className="col-lg-4">
                        {/* Vehicle No Sec */}
                        <CustomInput
                           require
                           label="Chassis No"
                           id="chasisNo"
                           placeholder="Enter Chassis No"
                           {...getFieldProps("chasisNo")}
                           errors={Boolean(errors.chasisNo) && Boolean(touched.chasisNo)}
                           message={errors.chasisNo}
                        />
                     </div>
                     <div className="col-lg-4">
                        {/* Vehicle No Sec */}
                        <CustomInput
                           require
                           label="Engine No"
                           id="engineNo"
                           placeholder="Enter Engine No"
                           onChange={formik.handleChange}
                           {...getFieldProps("engineNo")}
                           errors={Boolean(errors.engineNo) && Boolean(touched.engineNo)}
                           message={errors.engineNo}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomInput
                           require
                           label="Vehicle owner name"
                           id="vehicleOwner"
                           placeholder="Enter vehicle owner name"
                           {...getFieldProps("vehicleOwnerName")}
                           errors={
                              Boolean(errors.vehicleOwnerName) &&
                              Boolean(touched.vehicleOwnerName)
                           }
                           message={errors.vehicleOwnerName}
                        />
                     </div>

                     {/* Dimension  */}
                     <div className="col-lg-4">
                        <CustomDropdown
                           label="Dimension(L B H (ft))"
                           optionData={dimensionData}
                           {...getFieldProps("dimension")}
                           onChange={(value) => {
                              setFieldValue("dimension", value?.[0]?.value, true);
                           }}
                           errors={
                              Boolean(errors.dimension) && Boolean(touched.dimension)
                           }
                           message={errors.dimension}
                        />
                     </div>

                     {/* Fastag bank name Sec */}
                     <div className="col-lg-4">
                        <CustomInput
                           require
                           label="Fastag bank name"
                           id="fastagBankName"
                           placeholder="Enter Fastag bank name"
                           {...getFieldProps("fastagBankName")}
                           errors={
                              Boolean(errors.fastagBankName) &&
                              Boolean(touched.fastagBankName)
                           }
                           message={errors.fastagBankName}
                        />
                     </div>
                     {/* Vehicle Category Sec */}
                     <div className="col-lg-4">
                        <CustomDropdown
                           label="Vehicle Category"
                           require
                           optionData={vehicleCategoryData}
                           {...getFieldProps("vehicleCategory")}
                           onChange={(value) => {
                              setFieldValue("vehicleCategory", value?.[0]?.value);
                           }}
                           errors={
                              Boolean(errors.vehicleCategory) &&
                              Boolean(touched.vehicleCategory)
                           }
                           message={errors.vehicleCategory}
                        />
                     </div>
                     {/* Tonnage Sec */}
                     <div className="col-lg-4">
                        <CustomDropdown
                           require
                           label="Tonnage(KL)"
                           optionData={tonnageData}
                           {...getFieldProps("tonnage")}
                           onChange={(value) => {
                              setFieldValue("tonnage", value?.[0]?.value);
                           }}
                           errors={Boolean(errors.tonnage) && Boolean(touched.tonnage)}
                           message={errors.tonnage}
                        />
                     </div>

                     <div className="col-lg-4">
                        <label className="text-bold">
                           Fuel Type
                           <span className="text-danger">*</span>
                        </label>
                        <div className="form-group mt-2">
                           <CustomRadio
                              label="Diesel"
                              id="diesel"
                              value="Diesel"
                              name="fuelType"
                              defaultChecked={values.fuelType}
                              checked={values.fuelType === "Diesel"}
                              onChange={getFieldProps("fuelType").onChange}
                              // onChange={(event) => {
                              //    setFieldValue("fuelType", event.target.value);
                              //    setFuelType(event.target.value);
                              // }}
                           />
                           <CustomRadio
                              label="CNG"
                              id="cng"
                              value="CNG"
                              checked={values.fuelType === "CNG"}
                              name="fuelType"
                              onChange={getFieldProps("fuelType").onChange}
                              // onChange={(event) => {
                              //    setFieldValue("fuelType", event.target.value);
                              //    setFuelType(event.target.value);
                              // }}
                           />
                        </div>
                     </div>

                     {/* <div className="col-lg-4">
                        <CustomDropdown
                           require
                           label="Kilolitre(KL)"
                           optionData={kiloleterData}
                           {...getFieldProps("kiloleter")}
                           onChange={(value) => {
                              setFieldValue("kiloleter", value?.[0]?.value);
                           }}
                           errors={
                              Boolean(errors.kiloleter) && Boolean(touched.kiloleter)
                           }
                           message={errors.kiloleter}
                        />
                     </div> */}
                     <div className="col-lg-0"></div>

                     <div className="col-lg-6">
                        <CustomDropdown
                           require
                           label="Attach Location"
                           optionData={locationData}
                           {...getFieldProps("location")}
                           onChange={(value) => {
                              setFieldValue("location", value?.[0]?.value);
                           }}
                           errors={Boolean(errors.location) && Boolean(touched.location)}
                           message={errors.location}
                        />
                     </div>

                     <div className="col-lg-6">
                        <CustomDropdown
                           require
                           label="Company"
                           optionData={companyData}
                           {...getFieldProps("company")}
                           onChange={(value) => {
                              setFieldValue("company", value?.[0]?.value);
                           }}
                           errors={Boolean(errors.company) && Boolean(touched.company)}
                           message={errors.company}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomDropdown
                           require
                           label="Make"
                           optionData={makeData}
                           {...getFieldProps("make")}
                           onChange={(value) => {
                              setFieldValue("make", value?.[0]?.value);
                           }}
                           errors={Boolean(errors.make) && Boolean(touched.make)}
                           message={errors.make}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomMonthYear
                           label="Model (Month Year)"
                           {...getFieldProps("model")}
                           // onChange={(value) => {
                           //    setFieldValue("model", value?.[0]?.value);
                           // }}
                           errors={Boolean(errors.model) && Boolean(touched.model)}
                           message={errors.model}
                        />
                     </div>
                     <div className="col-lg-4">
                        <label className="text-bold">
                           Registration Certificate
                           <span className="text-danger">*</span>
                        </label>
                        <CustomFileUpload
                           accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                           onChange={(event) => {
                              setFieldValue(
                                 "registrationCertificate",
                                 event?.target?.files?.[0],
                              );
                           }}
                           value={getFieldProps("registrationCertificate").value}
                           errors={
                              Boolean(errors.registrationCertificate) &&
                              Boolean(touched.registrationCertificate)
                           }
                           message={errors.registrationCertificate}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomDatePicker
                           require
                           label="Insurance Expiry Date"
                           placeholder="Enter Insurance Expiry Date"
                           {...getFieldProps("insuranceExpiryDate")}
                           errors={
                              Boolean(errors.insuranceExpiryDate) &&
                              Boolean(touched.insuranceExpiryDate)
                           }
                           message={errors.insuranceExpiryDate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           label="Insurance Amount"
                           id="fitnessAmount"
                           placeholder="Enter Insurance Amount"
                           {...getFieldProps("insuranceAmount")}
                           errors={
                              Boolean(errors.insuranceAmount) &&
                              Boolean(touched.insuranceAmount)
                           }
                           message={errors.insuranceAmount}
                        />
                     </div>
                     <div className="col-lg-4">
                        <label className="text-bold">
                           Insurance Certificate
                           <span className="text-danger">*</span>
                        </label>
                        <CustomFileUpload
                           accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                           onChange={(event) => {
                              setFieldValue(
                                 "insuranceCertificate",
                                 event?.target?.files?.[0],
                              );
                           }}
                           value={getFieldProps("insuranceCertificate").value}
                           errors={
                              Boolean(errors.insuranceCertificate) &&
                              Boolean(touched.insuranceCertificate)
                           }
                           message={errors.insuranceCertificate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomDatePicker
                           require
                           label="Fitness Expiry Date"
                           placeholder="Enter Fitness Expiry Date"
                           {...getFieldProps("fitnessExpiryDate")}
                           errors={formik.errors.fitnessExpiryDate}
                           message={formik.errors.fitnessExpiryDate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           label="Fitness Amount"
                           id="fitnessAmount"
                           placeholder="Enter Fitness Amount"
                           {...getFieldProps("fitnessAmount")}
                           errors={formik.errors.fitnessAmount}
                           message={formik.errors.fitnessAmount}
                        />
                     </div>
                     <div className="col-lg-4">
                        <label className="text-bold">
                           Fitness Certificate
                           <span className="text-danger">*</span>
                        </label>
                        <CustomFileUpload
                           accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                           onChange={(event) => {
                              setFieldValue(
                                 "fitnessCertificate",
                                 event?.target?.files?.[0],
                              );
                           }}
                           value={getFieldProps("fitnessCertificate").value}
                           errors={formik.errors.fitnessCertificate}
                           message={formik.errors.fitnessCertificate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomDatePicker
                           label="Local Permit Expiry Date"
                           placeholder="Enter Local Permit Expiry Date"
                           {...getFieldProps("localPermitExpiryDate")}
                           errors={formik.errors.localPermitExpiryDate}
                           message={formik.errors.localPermitExpiryDate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           label="Local Permit Amount"
                           id="fitnessAmount"
                           placeholder="Enter Local Permit Amount"
                           {...getFieldProps("localPermitAmount")}
                           errors={formik.errors.localPermitAmount}
                           message={formik.errors.localPermitAmount}
                        />
                     </div>
                     <div className="col-lg-4">
                        <label className="text-bold">
                           Local Permit Document
                           {/* <span className="text-danger">*</span> */}
                        </label>
                        <CustomFileUpload
                           accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                           onChange={(event) => {
                              setFieldValue(
                                 "localPermitDocument",
                                 event?.target?.files?.[0],
                              );
                           }}
                           value={getFieldProps("localPermitDocument").value}
                           errors={formik.errors.localPermitDocument}
                           message={formik.errors.localPermitDocument}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomDatePicker
                           require
                           label="National Permit Expiry Date"
                           placeholder="Enter National Permit Expiry Date"
                           {...getFieldProps("nationalPermitExpiryDate")}
                           errors={formik.errors.nationalPermitExpiryDate}
                           message={formik.errors.nationalPermitExpiryDate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           label="National Permit Amount"
                           id="fitnessAmount"
                           placeholder="Enter National Permit Amount"
                           {...getFieldProps("nationalPermitAmount")}
                           errors={formik.errors.nationalPermitAmount}
                           message={formik.errors.nationalPermitAmount}
                        />
                     </div>
                     <div className="col-lg-4">
                        <label className="text-bold">National Permit Document</label>
                        <span className="text-danger">*</span>
                        <CustomFileUpload
                           accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                           onChange={(event) => {
                              setFieldValue(
                                 "nationalPermitDocument",
                                 event?.target?.files?.[0],
                              );
                           }}
                           value={getFieldProps("nationalPermitDocument").value}
                           errors={formik.errors.nationalPermitDocument}
                           message={formik.errors.nationalPermitDocument}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomDatePicker
                           label="PUC Expiry Date"
                           placeholder="Enter PUC Expiry Date"
                           {...getFieldProps("pucExpiryDate")}
                           errors={formik.errors.pucExpiryDate}
                           message={formik.errors.pucExpiryDate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           label="PUC Amount"
                           id="fitnessAmount"
                           placeholder="Enter PUC Amount"
                           {...getFieldProps("pucAmount")}
                           errors={formik.errors.pucAmount}
                           message={formik.errors.pucAmount}
                        />
                     </div>
                     <div className="col-lg-4">
                        <label className="text-bold">PUC Document</label>
                        <CustomFileUpload
                           accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                           onChange={(event) => {
                              setFieldValue("pucDocument", event?.target?.files?.[0]);
                           }}
                           value={getFieldProps("pucDocument").value}
                           errors={formik.errors.pucDocument}
                           message={formik.errors.pucDocument}
                        />
                     </div>

                     {/* PESO */}

                     <div className="col-lg-4">
                        <CustomDatePicker
                           require
                           label="PESO Expiry Date"
                           placeholder="Enter PESO Expiry Date"
                           {...getFieldProps("pesoExpiryDate")}
                           errors={formik.errors.pesoExpiryDate}
                           message={formik.errors.pesoExpiryDate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           label="PESO Amount"
                           id="pesoAmount"
                           placeholder="Enter PESO Amount"
                           {...getFieldProps("pesoAmount")}
                           errors={formik.errors.pesoAmount}
                           message={formik.errors.pesoAmount}
                        />
                     </div>
                     <div className="col-lg-4">
                        <label className="text-bold">
                           PESO Document
                           <span className="text-danger">*</span>
                        </label>
                        <CustomFileUpload
                           accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                           onChange={(event) => {
                              setFieldValue("pesoDocument", event?.target?.files?.[0]);
                           }}
                           value={getFieldProps("pesoDocument").value}
                           errors={formik.errors.pesoDocument}
                           message={formik.errors.pesoDocument}
                        />
                     </div>

                     {/* PESO End */}

                     {/* Purchase Record */}

                     <div className="col-lg-4">
                        <CustomDatePicker
                           label="Purchase Date"
                           placeholder="Enter Purchase Date"
                           {...getFieldProps("purchaseDate")}
                           errors={formik.errors.purchaseDate}
                           message={formik.errors.purchaseDate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           label="Purchase Amount"
                           id="pesoAmount"
                           placeholder="Enter Purchase Amount"
                           {...getFieldProps("purchaseAmount")}
                           errors={formik.errors.purchaseAmount}
                           message={formik.errors.purchaseAmount}
                        />
                     </div>
                     <div className="col-lg-4">
                        <label className="text-bold">Purchase Document</label>
                        <CustomFileUpload
                           accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                           onChange={(event) => {
                              setFieldValue(
                                 "purchaseDocument",
                                 event?.target?.files?.[0],
                              );
                           }}
                           value={getFieldProps("purchaseDocument").value}
                           errors={formik.errors.purchaseDocument}
                           message={formik.errors.purchaseDocument}
                        />
                     </div>

                     {/* Purchase Record End */}

                     <div className="col-lg-4">
                        <CustomDatePicker
                           require
                           createdBy
                           label="MV Tax Expiry Date"
                           placeholder="Enter MV Tax Expiry Date"
                           {...getFieldProps("mvTaxExpiryDate")}
                           errors={formik.errors.mvTaxExpiryDate}
                           message={formik.errors.mvTaxExpiryDate}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomInput
                           label="MV Tax Amount"
                           id="fitnessAmount"
                           placeholder="Enter MV Tax Amount"
                           {...getFieldProps("mvTaxAmount")}
                           errors={formik.errors.mvTaxAmount}
                           message={formik.errors.mvTaxAmount}
                        />
                     </div>
                     <div className="col-lg-4">
                        <label className="text-bold">
                           MV Tax
                           <span className="text-danger">*</span>
                        </label>
                        <CustomFileUpload
                           accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                           onChange={(event) => {
                              setFieldValue("mvTax", event?.target?.files?.[0]);
                           }}
                           value={getFieldProps("mvTax").value}
                           errors={formik.errors.mvTax}
                           message={formik.errors.mvTax}
                        />
                     </div>

                     <div className="col-lg-6">
                        <CustomInput
                           label="GPS Provider Name"
                           id="gpsProvider"
                           placeholder="Enter GPS Provider Name"
                           {...getFieldProps("gpsProviderName")}
                           errors={formik.errors.gpsProviderName}
                           message={formik.errors.gpsProviderName}
                        />
                     </div>
                     <div className="col-lg-6">
                        <CustomInput
                           label="GPS Amount"
                           id="fitnessAmount"
                           placeholder="Enter GPS Amount"
                           {...getFieldProps("gpsAmount")}
                           errors={formik.errors.gpsAmount}
                           message={formik.errors.gpsAmount}
                        />
                     </div>
                     <div className="col-lg-6">
                        <CustomInput
                           label="Fabricator Name"
                           id="fitnessAmount"
                           placeholder="Enter Fabricator Name"
                           {...getFieldProps("fabricatorName")}
                           errors={formik.errors.fabricatorName}
                           message={formik.errors.fabricatorName}
                        />
                     </div>

                     <div className="col-lg-6">
                        <CustomInput
                           label="Fabricator Location"
                           id="fitnessAmount"
                           placeholder="Enter Fabricator Location"
                           {...getFieldProps("fabricatorLocation")}
                           errors={formik.errors.fabricatorLocation}
                           message={formik.errors.fabricatorLocation}
                        />
                     </div>
                     <div className="col-lg-12 mt-4 mb-3">
                        <div className="card card-outline card-secondary p-3 bg-light border">
                           <h6 className="text-bold text-secondary mb-1">
                              Alert Contact for Document Expirations
                           </h6>
                           <p className="text-muted small mb-3">
                              Specify the contact person details below to notify them when
                              vehicle documents (Permit, Tax, Fitness, PUC, etc.) are
                              expiring.
                           </p>
                           <div className="row">
                              <div className="col-lg-6">
                                 <CustomInput
                                    label="Consultant Person Name"
                                    id="consultantPerson"
                                    placeholder="Enter Consultant Name"
                                    {...getFieldProps("consultantPerson")}
                                    errors={formik.errors.consultantPerson}
                                    message={formik.errors.consultantPerson}
                                 />
                              </div>
                              <div className="col-lg-6">
                                 <CustomInput
                                    label="Consultant Phone Number"
                                    id="consultantPhone"
                                    placeholder="Enter Consultant Phone Number"
                                    {...getFieldProps("consultantPhone")}
                                    errors={formik.errors.consultantPhone}
                                    message={formik.errors.consultantPhone}
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="card card-primary mt-5 p-2">
                  {/* --------------------------- EMI --------------------------------- */}

                  <div className="card-header d-flex align-items-center gap-2">
                     <h3 className="card-title">EMI Details</h3>

                     <div className="ml-3 ms-auto">
                        <div className="btn-group">
                           {/* YES BUTTON */}
                           <button
                              type="button"
                              className={`btn ${
                                 values.isEmi ? "btn-warning" : "btn-outline-warning"
                              }`}
                              onClick={() => setFieldValue("isEmi", true)}
                           >
                              Yes
                           </button>

                           {/* NO BUTTON */}
                           <button
                              type="button"
                              className={`btn ${
                                 !values.isEmi ? "btn-danger" : "btn-outline-danger"
                              }`}
                              onClick={() => setFieldValue("isEmi", false)}
                           >
                              No
                           </button>
                        </div>
                     </div>
                  </div>

                  {values.isEmi && (
                     <div className="row card-body">
                        <div className="col-lg-4">
                           <CustomDatePicker
                              require
                              label="EMI Start date"
                              placeholder="Enter vehicle owner name"
                              {...getFieldProps("emiStartDate")}
                              errors={
                                 Boolean(touched.emiStartDate) &&
                                 Boolean(errors.emiStartDate)
                              }
                              message={errors.emiStartDate}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomDatePicker
                              require
                              label="EMI End date"
                              placeholder="Enter vehicle owner name"
                              {...getFieldProps("emiEndDate")}
                              errors={
                                 Boolean(touched.emiEndDate) && Boolean(errors.emiEndDate)
                              }
                              message={errors.emiEndDate}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              label="Monthly EMI Obligation Date"
                              placeholder="Enter Monthly EMI Obligation Date"
                              {...getFieldProps("monthlyEmiObligationDate")}
                              errors={formik.errors.monthlyEmiObligationDate}
                              message={formik.errors.monthlyEmiObligationDate}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="EMI Amount"
                              id="emiAmount"
                              placeholder="Enter Amount"
                              {...getFieldProps("emiAmount")}
                              errors={formik.errors.emiAmount}
                              message={formik.errors.emiAmount}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              require
                              label="Number Of EMI"
                              id="noEMIAmount"
                              placeholder="Enter Amount"
                              {...getFieldProps("noEMIAmount")}
                              errors={formik.errors.noEMIAmount}
                              message={formik.errors.noEMIAmount}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              require
                              label="Total Loan Amount"
                              id="totalLoanAmount"
                              placeholder="Enter Amount"
                              {...getFieldProps("totalLoanAmount")}
                              errors={formik.errors.totalLoanAmount}
                              message={formik.errors.totalLoanAmount}
                           />
                        </div>

                        {/* Financed by sec */}
                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Financed by"
                              id="#financedBy"
                              placeholder="Enter name"
                              {...getFieldProps("financedBy")}
                              errors={
                                 Boolean(touched.financedBy) && Boolean(errors.financedBy)
                              }
                              message={errors.financedBy}
                           />
                        </div>
                     </div>
                  )}
               </div>

               <div className="mt-5">
                  <button
                     className="btn btn-primary px-4 py-3 float-right ml-3"
                     type="button"
                     onClick={handleSubmit}
                  >
                     <h6 className="mb-0 text-uppercase">Save</h6>
                  </button>
               </div>
            </div>
         </Form>
      </FormikProvider>
   );
};

export default VehicleDetails;
